import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Autocomplete,
  FormControl,
  OutlinedInput,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { isEmpty, isEqual } from 'lodash';

import AutocompleteCustom from '../../../../components/custom/CustomAutocomplete/CustomAutocomplete';
import DateTimePicker from '../../../../components/date-time/DateTimePicker/DateTimePicker';
import InputAdornmentClear from '../../../../components/input-adorment/InputAdornmentClear/InputAdornmentClear';
import InputAdornmentLoading from '../../../../components/input-adorment/InputAdornmentLoading/InputAdornmentLoading';
import PopperAutoWidth from '../../../../components/popper/PopperAutoWidth/PopperAutoWidth';
import { contactList } from '../../../../store/contact/contact.action';
import { clearContactData } from '../../../../store/contact/contact.slice';
import messageHelper from '../../../../store/message/message.helper';
import { getListSalesDelivery } from '../../../../store/sales/sales.action';
import {
  SLICE_NAME_SALES_DELIVERY_DATA,
  STATUS_REQUEST_LIST_CONTACT_DATA_PENDING,
  STATUS_REQUEST_LIST_SALES_DELIVERY_PENDING,
} from '../../../../utils/constants/store.constant';
import { initialSearchSalesDelivery } from '../../../../utils/data/display/initial-search-sales-delivery';
import { columnsSearchSalesDeliveryFormatDate } from '../../../../utils/data/display/table-list-sales-delivery';
import { minutesHandoverStatus } from '../../../../utils/data/label-value/minutes-of-handover-status';
import {
  salesDeliveryStatus,
  salesInvoiceStatus,
} from '../../../../utils/data/label-value/sales-status';
import { TERSIER_DEFAULT_LIST_PARAMS } from '../../../../utils/default/params.default';
import { DEFAULT_DELAY_TIMEOUT_IN_MS } from '../../../../utils/default/timeout.default';
import arrHelp from '../../../../utils/helpers/array.helpers';
import autocompleteHelper from '../../../../utils/helpers/component/autocomplete.helpers';
import dateHelpers from '../../../../utils/helpers/date.helpers';
import formatHelp from '../../../../utils/helpers/format.helpers';
import objHelper from '../../../../utils/helpers/object.helper';

import { styles } from './TableHeadSearchSalesDelivery.styles';

class TableHeadSearchSalesDelivery extends Component {
  constructor(props) {
    super(props);

    const { t } = props;

    this.state = {
      searchParams: initialSearchSalesDelivery(t),
      focusedInputName: null,
    };

    this.searchSearchDeliveryTimeoutID = null;
    this.searchContactDataTimeoutID = null;

    this.handleClearSingleFilter = this.handleClearSingleFilter.bind(this);

    this.handleOnChangeInput = this.handleOnChangeInput.bind(this);
    this.handleChangeAutocomplete = this.handleChangeAutocomplete.bind(this);
  }

  async handleClearSingleFilter(event) {
    event.stopPropagation();

    const { name } = event.currentTarget;

    const { searchParams: currSearchParams } = this.state;

    const newSearchParams = {
      ...currSearchParams,
      [name]: '',
    };

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
    }));

    const { sales } = this.props;
    const salesDeliveryData = sales[SLICE_NAME_SALES_DELIVERY_DATA];

    if (sales.statusRequest === STATUS_REQUEST_LIST_SALES_DELIVERY_PENDING) return;

    const paginate = !isEmpty(salesDeliveryData) ? salesDeliveryData.per_page : 20;

    await this.props.getListSalesDelivery({
      paginate,
      ...newSearchParams,
    });
  }

  handleOnChangeDate(newValueDate) {
    const { searchParams: currSearchParams } = this.state;

    const isDateValueNotChanged = isEqual(
      newValueDate,
      objHelper.filterKeyObj(currSearchParams, [], columnsSearchSalesDeliveryFormatDate),
    );

    if (isDateValueNotChanged) return;

    if (!isEmpty(newValueDate)) {
      const { from_date, to_date } = newValueDate;

      if (
        !dateHelpers.isValidDateV2(new Date(from_date)) ||
        !dateHelpers.isValidDateV2(new Date(to_date))
      ) {
        const { t } = this.props;

        this.props.setFailedMessage(
          t('dashboard.sales.sales-delivery.message.invalid-date-format.primary'),
          t('dashboard.sales.sales-delivery.message.invalid-date-format.secondary'),
        );

        return;
      }
    }

    const newSearchParams = {
      ...currSearchParams,
      ...newValueDate,
    };

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
    }));

    if (this.searchSearchDeliveryTimeoutID) clearTimeout(this.searchSearchDeliveryTimeoutID);

    this.searchSearchDeliveryTimeoutID = setTimeout(async () => {
      const salesDeliveryData = this.props.sales[SLICE_NAME_SALES_DELIVERY_DATA];

      const paginate = !isEmpty(salesDeliveryData)
        ? salesDeliveryData.per_page
        : TERSIER_DEFAULT_LIST_PARAMS.paginate;

      return await this.props.getListSalesDelivery({
        paginate,
        ...newSearchParams,
      });
    }, DEFAULT_DELAY_TIMEOUT_IN_MS);
  }

  handleOnChangeInput(event) {
    const { name, value } = event.target;

    const { searchParams: currSearchParams } = this.state;

    let newSearchParams = {
      ...currSearchParams,
      [name]: value,
    };

    if (name === 'customer_name') {
      newSearchParams = {
        ...newSearchParams,
        customer_name_container: {
          customer_name: value,
          contact_name: value,
        },
      };
    }

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
      focusedInputName: name,
    }));

    if (name === 'customer_name') {
      const { contact } = this.props;

      if (contact.statusRequest === STATUS_REQUEST_LIST_CONTACT_DATA_PENDING) return;

      if (this.searchContactDataTimeoutID) clearTimeout(this.searchContactDataTimeoutID);

      this.searchContactDataTimeoutID = setTimeout(async () => {
        return await this.props.getListContact({
          contact_name: value,
          type: ['is_customer'],
          paginate: TERSIER_DEFAULT_LIST_PARAMS.paginate,
        });
      }, DEFAULT_DELAY_TIMEOUT_IN_MS);

      return;
    }

    if (this.searchSearchDeliveryTimeoutID) clearTimeout(this.searchSearchDeliveryTimeoutID);

    this.searchSearchDeliveryTimeoutID = setTimeout(async () => {
      const salesDeliveryData = this.props.sales;

      const paginate = !isEmpty(salesDeliveryData)
        ? salesDeliveryData.per_page
        : TERSIER_DEFAULT_LIST_PARAMS.paginate;

      return await this.props.getListSalesDelivery({
        paginate,
        ...newSearchParams,
      });
    }, DEFAULT_DELAY_TIMEOUT_IN_MS);
  }

  async handleOnOpenAutocomplete(event, name) {
    event.preventDefault();

    if (name) {
      this.setState((prevState) => ({
        ...prevState,
        focusedInputName: name,
      }));
    }

    const { contact } = this.props;

    const isCanHitContactAPI =
      name === 'customer_name' &&
      contact.statusRequest !== STATUS_REQUEST_LIST_CONTACT_DATA_PENDING;

    if (isCanHitContactAPI) {
      await this.props.getListContact({
        ...TERSIER_DEFAULT_LIST_PARAMS,
        type: ['is_customer'],
      });
    }
  }

  async handleOnScrollAutocomplete(name) {
    if (name === 'customer_name') {
      const { contactData } = this.props.contact;

      if (isEmpty(contactData)) return;

      const {
        current_page,
        next_page_url,
        per_page: paginate,
        search_contact_name: contact_name,
      } = contactData;

      if (!next_page_url) return;

      await this.props.getListContact({
        page: current_page + 1,
        paginate,
        type: ['is_customer'],
        contact_name,
        isRewriteAll: false,
      });
    }
  }

  async handleOnCloseAutocomplete(event, name) {
    if (name === 'customer_name') {
      await this.props.clearContactData();
    }

    this.setState((prevState) => ({
      ...prevState,
      focusedInputName: '',
    }));
  }

  /**
   *
   * @param { object } event built-in event data
   * @param { array } newValue selected new value autocomplete
   * @param { string } containerName name of container data, usually contain all data before ge data in secondary name
   * @param { string } secondaryName name container for handling store data for send to BE
   * @param { string } valueSecondaryKey name key of container data value
   * @returns
   *      set new state and hit purchase order again
   */
  async handleChangeAutocomplete(event, newValue, containerName, secondaryName, valueSecondaryKey) {
    event.preventDefault();

    const { searchParams: currSearchParams } = this.state;

    let newValueSecondaryContainer = newValue ? newValue[valueSecondaryKey] : newValue;

    if (
      containerName === 'statusContainer' ||
      containerName === 'status_invoice_container' ||
      containerName === 'sales_handover_status_container'
    ) {
      // check is current params is contained 'all' status
      // when current params contained and incoming data contained another status, then change into incoming data
      // check is new value is contained 'all' status
      // when contained change new value into 'all' status
      if (!isEmpty(currSearchParams[containerName])) {
        const isCurrentStatusContainValueAll =
          currSearchParams[containerName].some((nv) => nv.value === 'all') && newValue.length > 1;

        const isNewValueContainedValueAll = newValue.some((nv) => nv.value === 'all');

        if (isCurrentStatusContainValueAll) {
          newValue = newValue.filter((nv) => nv.value !== 'all');
        } else if (isNewValueContainedValueAll) {
          newValue = newValue.filter((nv) => nv.value === 'all');
        }
      }

      newValueSecondaryContainer = valueSecondaryKey
        ? newValue.map((val) => val[valueSecondaryKey])
        : newValue;
    }

    let newSearchParams = {
      ...currSearchParams,
      [containerName]: newValue,
      [secondaryName]: newValueSecondaryContainer,
    };

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
    }));

    const keysIncludeItemAll = Object.keys(newSearchParams).reduce((statusAllKeys, currentKey) => {
      if (
        !isEmpty(newSearchParams[currentKey]) &&
        Array.isArray(newSearchParams[currentKey]) &&
        newSearchParams[currentKey].includes('all')
      ) {
        statusAllKeys = statusAllKeys.concat(currentKey);
      }

      return statusAllKeys;
    }, []);

    if (keysIncludeItemAll.length) {
      newSearchParams = objHelper.filterKeyObj(newSearchParams, keysIncludeItemAll);
    }

    const salesDeliveryData = this.props.sales[SLICE_NAME_SALES_DELIVERY_DATA];

    const paginate = !isEmpty(salesDeliveryData)
      ? salesDeliveryData.per_page
      : TERSIER_DEFAULT_LIST_PARAMS.paginate;

    const isCanRemoveStatusKeyOnSearchParams =
      (!isEmpty(currSearchParams.status) &&
        currSearchParams.status.includes('all') &&
        containerName !== 'statusContainer') ||
      (!isEmpty(newValue) &&
        !isEmpty(newValueSecondaryContainer) &&
        newValueSecondaryContainer.includes('all') &&
        containerName == 'statusContainer');

    // only when data status is 'all' status
    if (isCanRemoveStatusKeyOnSearchParams) {
      const removingPurchaseStatusParams = objHelper.filterKeyObj(newSearchParams, ['status']);

      return await this.props.getListSalesDelivery({
        paginate,
        ...removingPurchaseStatusParams,
      });
    }

    return await this.props.getListSalesDelivery({
      paginate,
      ...newSearchParams,
    });
  }

  render() {
    const { searchParams, focusedInputName } = this.state;

    const {
      statusContainer: currStatusContainer,
      status_invoice_container: currStatusInvoiceContainer,
      sales_handover_status_container: currStatusMinutesHandoverContainer,
      customer_name_container,
    } = searchParams;

    const { t, i18n, classes, columnsTableHeaderSalesDelivery, contact, sales } = this.props;

    const { language: languageI18n } = i18n;

    // setting on purchase invoice status list with translation
    const salesDeliveryStatusList = salesDeliveryStatus(t);
    const salesInvoiceStatusList = salesInvoiceStatus(t);
    const minutesHandoverStatusList = minutesHandoverStatus(t);

    const isSalesDeliveryLoadingData =
      sales.statusRequest === STATUS_REQUEST_LIST_SALES_DELIVERY_PENDING;

    // set temporary status purchase invoice for handle change translation from user
    const valueOnCurrentStatusContainer = arrHelp.mapWithExistedValue(currStatusContainer, 'value');
    const valueOnCurrentStatusInvoiceContainer = arrHelp.mapWithExistedValue(
      currStatusInvoiceContainer,
      'value',
    );
    const valueOnCurrentMinutesHandoverStatusContainer = arrHelp.mapWithExistedValue(
      currStatusMinutesHandoverContainer,
      'value',
    );

    const tempStatusSalesDeliveryContainer = salesDeliveryStatusList.filter((status) => {
      if (valueOnCurrentStatusContainer.includes(status.value)) {
        return status;
      }
    });

    const tempStatusSalesInvoiceContainer = salesInvoiceStatusList.filter((status) => {
      if (valueOnCurrentStatusInvoiceContainer.includes(status.value)) {
        return status;
      }
    });

    const tempStatusMinutesHandOverContainer = minutesHandoverStatusList.filter((status) => {
      if (valueOnCurrentMinutesHandoverStatusContainer.includes(status.value)) {
        return status;
      }
    });

    const { contactData } = contact;

    let contactDataList = [];
    let paginateContactData = TERSIER_DEFAULT_LIST_PARAMS.paginate;

    if (!isEmpty(contactData)) {
      if (Array.isArray(contactData.data)) {
        contactDataList = contactData.data;
      }

      paginateContactData = contactData.per_page;
    }

    return (
      <TableHead className={classes.TableHeadMainContainer}>
        <TableRow>
          {!isEmpty(columnsTableHeaderSalesDelivery) &&
            columnsTableHeaderSalesDelivery.map((coloumnHeader, index) => {
              if (!coloumnHeader.name_input) {
                return (
                  <TableCell
                    key={index}
                    align={coloumnHeader.align}
                    style={{
                      verticalAlign: 'top',
                      alignItems: 'flex-end',
                      width: coloumnHeader.width,
                      minWidth: coloumnHeader.minWidth,
                      maxWidth: coloumnHeader.maxWidth,
                    }}
                    className={classes.tableCellMain}
                  >
                    <p>{coloumnHeader.label}</p>
                  </TableCell>
                );
              }

              if (columnsSearchSalesDeliveryFormatDate.includes(coloumnHeader.name_input)) {
                return (
                  <TableCell
                    key={index}
                    align={coloumnHeader.align}
                    style={{ width: coloumnHeader.width }}
                    className={classes.tableCellMain}
                  >
                    <p>{coloumnHeader.label}</p>
                    <DateTimePicker
                      startDate={searchParams['from_date']}
                      endDate={searchParams['to_date']}
                      textCancel={t('button.cancel')}
                      textApply={t('button.apply')}
                      placeHolderInput={coloumnHeader.placeholder}
                      onSelectedChange={(value) => this.handleOnChangeDate(value)}
                      locale={languageI18n}
                      defaultKeyStartDate={'from_date'}
                      defaultKeyEndDate={'to_date'}
                      isDisabledInput={isSalesDeliveryLoadingData}
                    />
                  </TableCell>
                );
              }

              if (coloumnHeader.name_input === 'status') {
                return (
                  <TableCell
                    key={index}
                    align={coloumnHeader.align}
                    style={{
                      width: coloumnHeader.width,
                      maxWidth: coloumnHeader.maxWidth,
                      minWidth: coloumnHeader.minWidth,
                    }}
                    className={classes.tableCellMain}
                  >
                    <p>{coloumnHeader.label}</p>
                    <FormControl fullWidth>
                      <Autocomplete
                        id='multiple-limit-tages-status-sales'
                        size='small'
                        multiple
                        limitTags={1}
                        name={coloumnHeader.name_input}
                        className={classes.autocompleteSalesStatus}
                        value={tempStatusSalesDeliveryContainer}
                        options={salesDeliveryStatusList}
                        disabled={isSalesDeliveryLoadingData}
                        getOptionLabel={(option) =>
                          autocompleteHelper.getOptionLabel(option, 'label')
                        }
                        isOptionEqualToValue={(option, value) =>
                          autocompleteHelper.isOptionEqualToValue(option, value, 'value')
                        }
                        onChange={(event, newValue) => {
                          this.handleChangeAutocomplete(
                            event,
                            newValue,
                            'statusContainer',
                            'status',
                            'value',
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              isEmpty(searchParams.statusContainer) ? coloumnHeader.placeholder : ''
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </TableCell>
                );
              }

              if (coloumnHeader.name_input === 'status_invoice') {
                return (
                  <TableCell
                    key={index}
                    align={coloumnHeader.align}
                    style={{
                      width: coloumnHeader.width,
                      maxWidth: coloumnHeader.maxWidth,
                      minWidth: coloumnHeader.minWidth,
                    }}
                    className={classes.tableCellMain}
                  >
                    <p>{coloumnHeader.label}</p>
                    <FormControl fullWidth>
                      <Autocomplete
                        id='multiple-limit-tages-status-sales'
                        size='small'
                        multiple
                        limitTags={1}
                        name={coloumnHeader.name_input}
                        className={classes.autocompleteSalesStatus}
                        value={tempStatusSalesInvoiceContainer}
                        options={salesInvoiceStatusList}
                        disabled={isSalesDeliveryLoadingData}
                        getOptionLabel={(option) =>
                          autocompleteHelper.getOptionLabel(option, 'label')
                        }
                        isOptionEqualToValue={(option, value) =>
                          autocompleteHelper.isOptionEqualToValue(option, value, 'value')
                        }
                        onChange={(event, newValue) => {
                          this.handleChangeAutocomplete(
                            event,
                            newValue,
                            'status_invoice_container',
                            'status_invoice',
                            'value',
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              isEmpty(searchParams.status_invoice_container)
                                ? coloumnHeader.placeholder
                                : ''
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </TableCell>
                );
              }

              if (coloumnHeader.name_input === 'sales_handover_status') {
                return (
                  <TableCell
                    key={index}
                    align={coloumnHeader.align}
                    style={{
                      width: coloumnHeader.width,
                      maxWidth: coloumnHeader.maxWidth,
                      minWidth: coloumnHeader.minWidth,
                    }}
                    className={classes.tableCellMain}
                  >
                    <p>{coloumnHeader.label}</p>
                    <FormControl fullWidth>
                      <Autocomplete
                        id='multiple-limit-tages-status-sales'
                        size='small'
                        multiple
                        limitTags={1}
                        name={coloumnHeader.name_input}
                        className={classes.autocompleteSalesStatus}
                        value={tempStatusMinutesHandOverContainer}
                        options={minutesHandoverStatusList}
                        disabled={isSalesDeliveryLoadingData}
                        getOptionLabel={(option) =>
                          autocompleteHelper.getOptionLabel(option, 'label')
                        }
                        isOptionEqualToValue={(option, value) =>
                          autocompleteHelper.isOptionEqualToValue(option, value, 'value')
                        }
                        onChange={(event, newValue) => {
                          this.handleChangeAutocomplete(
                            event,
                            newValue,
                            'sales_handover_status_container',
                            'sales_handover_status',
                            'value',
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              isEmpty(searchParams.sales_handover_status_container)
                                ? coloumnHeader.placeholder
                                : ''
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </TableCell>
                );
              } else if (coloumnHeader.name_input === 'customer_name') {
                return (
                  <TableCell
                    key={index}
                    align={coloumnHeader.align}
                    style={{ width: coloumnHeader.width, maxWidth: coloumnHeader.maxWidth }}
                    className={classes.tableCellMain}
                  >
                    <p>{coloumnHeader.label}</p>
                    <FormControl fullWidth>
                      <AutocompleteCustom
                        id='customer_name'
                        name='customer_name'
                        size='small'
                        options={contactDataList}
                        value={customer_name_container}
                        autoHighlight
                        isPaginated={true}
                        totalOptions={autocompleteHelper.getOptionPaginatedAutocomplete(
                          contactDataList,
                          paginateContactData,
                          3,
                        )}
                        onOpen={(event) => this.handleOnOpenAutocomplete(event, 'customer_name')}
                        onClose={(event) => this.handleOnCloseAutocomplete(event, 'customer_name')}
                        onChange={(event, newValue) =>
                          this.handleChangeAutocomplete(
                            event,
                            newValue,
                            'customer_name_container',
                            'customer_name',
                            'contact_name',
                          )
                        }
                        getOptionLabel={(options) =>
                          autocompleteHelper.getInputValue(
                            options,
                            ['contact_code', 'contact_name'],
                            ['contact_name'],
                            formatHelp.contactCodeWithName,
                          )
                        }
                        isOptionEqualToValue={(option, value) =>
                          autocompleteHelper.isOptionEqualToValue(option, value, 'contact_id')
                        }
                        ListboxProps={{
                          onScroll: (event) => {
                            // i need scroll into bottom view when api was hitted
                            const { offsetHeight, scrollHeight, scrollTop } = event.target;

                            const isEndOfScroll = offsetHeight + scrollTop >= scrollHeight;

                            if (isEndOfScroll) {
                              this.handleOnScrollAutocomplete('customer_name');
                            }
                          },
                        }}
                        PopperComponent={PopperAutoWidth}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id='customer_name'
                            name='customer_name'
                            placeholder={t(
                              'dialog.base-add-update-sales-order.input.customer-name.placeholder',
                            )}
                            onChange={(event) => this.handleOnChangeInput(event)}
                            readOnly={
                              contact.statusRequest === STATUS_REQUEST_LIST_CONTACT_DATA_PENDING
                            }
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornmentLoading
                                  isLoading={
                                    focusedInputName === 'customer_name' &&
                                    contact.statusRequest ===
                                      STATUS_REQUEST_LIST_CONTACT_DATA_PENDING
                                  }
                                  defaultInputAdornment={params.InputProps.endAdornment}
                                />
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </TableCell>
                );
              }

              return (
                <TableCell
                  key={index}
                  align={coloumnHeader.align}
                  style={{ width: coloumnHeader.width }}
                  className={classes.tableCellMain}
                >
                  <p>{coloumnHeader.label}</p>
                  <FormControl fullWidth>
                    <OutlinedInput
                      name={coloumnHeader.name_input}
                      autoFocus={coloumnHeader.name_input === focusedInputName}
                      readOnly={isSalesDeliveryLoadingData}
                      size='small'
                      placeholder={coloumnHeader.placeholder}
                      onChange={this.handleOnChangeInput}
                      value={searchParams[coloumnHeader.name_input]}
                      {...(searchParams[coloumnHeader.name_input] && {
                        endAdornment: (
                          <InputAdornmentClear
                            isShowIcon={searchParams[coloumnHeader.name_input]}
                            iconName={coloumnHeader.name_input}
                            isLoadingSearch={isSalesDeliveryLoadingData}
                            onClickClearButton={this.handleClearSingleFilter}
                          />
                        ),
                      })}
                    />
                  </FormControl>
                </TableCell>
              );
            })}
        </TableRow>
      </TableHead>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contact: state.contact,
    sales: state.sales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListContact: (paramsGetListContact) => dispatch(contactList(paramsGetListContact)),
    getListSalesDelivery: (paramsGetListPurchaseInvoice) =>
      dispatch(getListSalesDelivery(paramsGetListPurchaseInvoice)),
    clearContactData: () => dispatch(clearContactData()),
    setFailedMessage: (primaryText, secondaryText) =>
      messageHelper.failedMessage(dispatch, primaryText, secondaryText, false),
  };
};

const stylingTableHeadSearchSalesDelivery = withStyles(styles)(TableHeadSearchSalesDelivery);

const TableHeadPurchaseOrderTranslate = withTranslation()(stylingTableHeadSearchSalesDelivery);

const ConnectedTableHeadSearchSalesDelivery = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableHeadPurchaseOrderTranslate);

export default ConnectedTableHeadSearchSalesDelivery;
